"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToAbsoluteImageURI = exports.XXX = exports.XX = exports.X = exports.WEBP_TYPE = exports.WEBP_SVG_TYPE = exports.WEBP_PNG_TYPE = exports.WEBP_EXT = exports.SVG_TYPE = exports.SVG_EXT = exports.QUALITY_IMAGE_60 = exports.PNG_EXT = exports.MODE = exports.JPG_EXT = exports.IMAGE_MAX_SIZE = exports.GIF_EXT = void 0;
var IMAGE_MAX_SIZE = exports.IMAGE_MAX_SIZE = 9961472;
var QUALITY_IMAGE_60 = exports.QUALITY_IMAGE_60 = '60';
var X = exports.X = '1x';
var XX = exports.XX = '2x';
var XXX = exports.XXX = '3x';
var WEBP_EXT = exports.WEBP_EXT = 'webp';
var PNG_EXT = exports.PNG_EXT = 'png';
var SVG_EXT = exports.SVG_EXT = 'svg';
var GIF_EXT = exports.GIF_EXT = 'gif';
var JPG_EXT = exports.JPG_EXT = 'jpg';
var WEBP_TYPE = exports.WEBP_TYPE = [WEBP_EXT];
var WEBP_PNG_TYPE = exports.WEBP_PNG_TYPE = [WEBP_EXT, PNG_EXT];
var WEBP_SVG_TYPE = exports.WEBP_SVG_TYPE = [SVG_EXT, WEBP_EXT];
var SVG_TYPE = exports.SVG_TYPE = [SVG_EXT];
var MODE = exports.MODE = {
  LIGHT: 'light',
  DARK: 'dark'
};
var themeMap = {
  olx: '',
  letgo: 'letgo/',
  otoplus: 'otoplus/',
  '321sprzedane': '321sprzedane/'
};
var convertToAbsoluteImageURI = exports.convertToAbsoluteImageURI = function convertToAbsoluteImageURI(baseUri, uri) {
  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'olx';
  var url = uri;
  if (uri && baseUri && uri.indexOf('https://') === -1) {
    url = "".concat(baseUri).concat(uri);
  }
  url = url.replace('/$theme$/', themeMap[theme] || '');
  return url;
};